// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610260526/js/" + chunkId + "." + {"44":"b297f215","225":"13ca9d76","481":"1b693071","486":"331172de","770":"3f4f3401"}[chunkId] + ".0.8215868821284793.chunk.js";
};